export const READ_STATUS_CHANGE = 'READ_STATUS_CHANGE';
export const readStatusChange = (readStatus) => ({
  type: READ_STATUS_CHANGE,
  payload: { readStatus },
});
